import RelationshipsListContainer from "../../../components/relationships/RelationshipsList";

export default function Relationships() {
  return <RelationshipsListContainer />;
}
